import { controllers } from 'chart.js'

class GaugeController extends controllers.BarController {

    draw() {
        
        const { 
            ctx, 
            chartArea: {
                top, bottom
            }            
        } = this.chart

        const {data} = this.getMeta()
        //console.log("data", data)
        for (let entry of data){
            ctx.beginPath()
            //console.log("entry", entry)
            if(entry.x > 261) {
                entry.x = 261 //width of chart + start of chart, 250.03 + 11.66 rounded down to account for width of gauge
                entry.width = 261 // This has however made the animation much faster for higher values
            }
            //console.log(entry.x)
            ctx.moveTo(entry.x, top)
            ctx.lineTo(entry.x, bottom)
            ctx.strokeStyle = entry.options.backgroundColor
            ctx.lineWidth = 2
            ctx.stroke()
        }
        
    }
}

GaugeController.id = 'gauge'
GaugeController.defaults = controllers.BarController.defaults

export default GaugeController